import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";

interface CustomButtonGroupProps {
  buttons: { value: string; label: string }[];
  value: string;
  onChange: (
    event: React.MouseEvent<HTMLElement>,
    newValue: string | null
  ) => void;
}

const CustomButtonGroup: React.FC<CustomButtonGroupProps> = ({
  buttons,
  value,
  onChange,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
      }}
    >
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={onChange}
        aria-label="button group"
        sx={{
          backgroundColor: "#f5f5f5",
          borderRadius: "24px",
          overflow: "hidden",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        {buttons.map((button) => (
          <ToggleButton
            key={button.value}
            value={button.value}
            aria-label={button.label}
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              flex: 1,
              backgroundColor: "#F2EEE8",
              padding: "0.5rem",
              minWidth: "6rem",
              border: "none",
              color: "#000000",
              "&:hover": {
                backgroundColor: value === button.value ? "#4E7E6E" : "#F2EEE8",
              },
              "&.Mui-selected": {
                color: "#fff",
                backgroundColor: "#4E7E6E",
                "&:hover": {
                  backgroundColor:
                    value === button.value ? "#4E7E6E" : "#F2EEE8",
                },
              },
            }}
          >
            {button.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default CustomButtonGroup;
